/**
 * .sanitize-currency
 * Register a trigger for the .sanitize-currency
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


;(function($) {

    "use strict";

    $(function(){
        /**
         * Define the method
         * @return string
         */
        var sanitizeCurrency = function(){
            return $(this).val( $.trim( $(this).val() ).replace(/[^\d.-]/g,'') );
        }

        /**
         * Define selector
         *
         * @type {String}
         */
        var $selector = 'input.sanitize-currency';

        /**
         * Append method to any input with class .sanitize-currency
         */
        $($selector).blur(sanitizeCurrency);

        /**
         * Append method to any input with class .sanitize-currency... after the modal is loaded
         */
        $('#remote').on('loaded.bs.modal', function (e) {
            // Identify the Modal
            var modal  = $(this);
            // Attach the blur action
            modal.find($selector).blur(sanitizeCurrency);
        });
    });

})(window.jQuery);
